import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import { ChangeEvent, memo, useEffect, useState } from 'react';
import Router from '@/components/common/router';

import * as Styles from './styles';
import {
    BH_CAR_REGISTRATION_NUMBER_REGEX,
    CAR_REGISTRATION_NUMBER_REGEX,
    registrationNumberRegex,
} from '@/constants/common';
import { fetchVehicleDetails, getRegexData } from '../../api';
import router from '@/components/common/router';
import { ROUTEMAP } from '../../constants';
import WaitingLoader from '@/assets/Icons/waiting-loader.svg';
import CarDetailsIcon from '@/assets/Icons/car-details.svg';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { viewPageAPI, trackEventAPI } from '@/analytics/middleware';
import {
    VIEW_PAGE_ENTER_CAR_NUMBER,
    TAB_BTN_SUBMIT_CAR_REG_NUMBER,
    TAP_BTN_ADD_CAR_MANUALLY,
} from '@/analytics/events';
import { useRouter } from 'next/router';
import useOnce from '@/hooks/useOnce';
interface SavedAssetModalProps {
    show: boolean;
    close: () => void;
    newAssetHandler: (value: string) => Promise<void | string>;
    isNew?: boolean;
}

const NewAssetModal = ({
    show,
    close,
    newAssetHandler,
    isNew = false,
}: SavedAssetModalProps) => {
    const initialState = {
        vehicleNumber: {
            value: '',
            valid: false,
            touched: false,
        },
    };
    const [showLoader, setShowLoader] = useState(false);
    const [inputs, setInputs] = useState(initialState);
    const [regexData, setRegexData] = useState(registrationNumberRegex);

    const handleVehicleNumberOnBlur = () => {
        setInputs((previousState) => ({
            ...previousState,
            vehicleNumber: {
                ...previousState.vehicleNumber,
                touched: true,
            },
        }));
    };

    // const handleVehicleNumberInput = (event: ChangeEvent<HTMLInputElement>) => {
    //     let enteredValue: string = event.target?.value;
    //     const vehicleNumberRegex = new RegExp(CAR_REGISTRATION_NUMBER_REGEX);
    //     const bhVehicleRegex = new RegExp(BH_CAR_REGISTRATION_NUMBER_REGEX);
    //     setInputs((previousState) => ({
    //         ...previousState,
    //         vehicleNumber: {
    //             ...previousState.vehicleNumber,
    //             value: enteredValue.toUpperCase(),
    //             valid:
    //                 vehicleNumberRegex.test(enteredValue) ||
    //                 bhVehicleRegex.test(enteredValue),
    //         },
    //     }));
    // };

    const handleVehicleNumberInput = (event: ChangeEvent<HTMLInputElement>) => {
        const enteredValue: string = event.target.value.toUpperCase();

        // Check if input matches any of the regex patterns
        const isValid = regexData.some((regex: any) =>
            new RegExp(regex).test(enteredValue)
        );

        setInputs((previousState) => ({
            ...previousState,
            vehicleNumber: {
                ...previousState.vehicleNumber,
                value: enteredValue,
                valid: isValid,
            },
        }));
    };

    const handleSubmit = async () => {
        trackEventAPI({
            event_name: TAB_BTN_SUBMIT_CAR_REG_NUMBER,
            customAttributes: {
                registration_number: inputs.vehicleNumber.value,
            },
            isFakeDoor: true,
        });
        setShowLoader(true);
        //newAssetHandler(inputs.vehicleNumber.value);
        const status = await newAssetHandler(inputs.vehicleNumber.value);
        if (status === 'Invalid vehicle') {
            setShowLoader(false);

            setInputs((previousState) => ({
                ...previousState,
                vehicleNumber: {
                    ...previousState.vehicleNumber,
                    value: inputs.vehicleNumber.value,
                    valid: false,
                },
            }));
        }
    };

    const handleBottomCtaClick = () => {
        trackEventAPI({
            event_name: TAP_BTN_ADD_CAR_MANUALLY,
            customAttributes: {
                saved_asset: localStorage.getItem('mmv') ? true : false,
            },
            isFakeDoor: true,
        });
        Router.push('/ad-services/mmv');
    };

    useEffect(() => {
        async function getRegex() {
            const data = await getRegexData();
            console.log('regex', data);
            if (data) {
                setRegexData(data);
            }
        }

        getRegex();
    }, []);
    useEffect(() => {
        if (show) {
            viewPageAPI({
                event_name: VIEW_PAGE_ENTER_CAR_NUMBER,
                customAttributes: {},
                isFakeDoor: true,
            });
            setShowLoader(false);
        }

        return () => {
            setInputs(initialState);
        };
    }, [show]);

    return (
        <>
            <MobileOrDesktopDialog show={show} onClose={close}>
                <Styles.Container>
                    {!showLoader && (
                        <>
                            <Styles.InfoContainer>
                                {/* <CarDetailsIcon /> */}
                                <Styles.InfoText>
                                    {isNew
                                        ? 'Enter your car registration number'
                                        : 'We can’t find your car details at the moment. Can you enter your car registration number?'}
                                    {/* //Enter your car registration number<br/> */}
                                </Styles.InfoText>
                            </Styles.InfoContainer>

                            <Styles.CustomInput
                                type="text"
                                name="newVehicleNumber"
                                labelText="Car vehicle number"
                                value={inputs.vehicleNumber.value}
                                errMsg="Enter a valid vehicle number"
                                onBlur={handleVehicleNumberOnBlur}
                                hasError={
                                    !inputs.vehicleNumber.valid &&
                                    inputs.vehicleNumber.touched
                                }
                                onChange={handleVehicleNumberInput}
                                // rightElement={
                                //     <Styles.ButtonContainer
                                //         disabled={!inputs.vehicleNumber.valid}
                                //     >
                                //         <Styles.Forward
                                //             onClick={handleSubmit}
                                //         />
                                //     </Styles.ButtonContainer>
                                // }
                            />
                            <Styles.CTAContainer>
                                <PrimaryButton
                                    onClick={handleSubmit}
                                    disabled={!inputs.vehicleNumber.valid}
                                >
                                    Proceed
                                </PrimaryButton>

                                {/* <Styles.Link onClick={handleBottomCtaClick}>
                                    I don't know the car number
                                </Styles.Link>  */}
                            </Styles.CTAContainer>
                        </>
                    )}
                    {showLoader && (
                        <Styles.LoaderContainer>
                            <WaitingLoader />

                            <Styles.LoaderText>
                                Fetching your car details...
                            </Styles.LoaderText>

                            <PrimaryButton loading />
                        </Styles.LoaderContainer>
                    )}
                </Styles.Container>
            </MobileOrDesktopDialog>
        </>
    );
};

export default memo(NewAssetModal);
